import React from 'react';
import { Provider } from 'react-redux'
import { render } from 'react-dom'
import { BrowserRouter as Router } from 'react-router-dom'
import * as App from 'modules/app/App'
import * as Routes from './modules/app/Routes'
import * as BrowserDetection from 'fw/misc/BrowserDetection'
import Store from 'modules/state/Store'
import BrowserNotSupported from 'areas/shared/errors/browserNotSupported/BrowserNotSupported'

// Initiate app
App.start();

let comp = (
    <Provider store={Store}>
        <Router>
            <Routes.Root />
        </Router>
    </Provider>
);

if (!BrowserDetection.isBrowserSupported())
    comp = <BrowserNotSupported />

// Render
render(comp, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js